// Frans (fr-FR), cultureApp: zelfde vorm als cultureApp.nl.ts. Rustig, geen uitroeptekens, nooit
// over nationaliteit.
export const appCultureFr = {
    hidden: {
        groupFaithNone: 'Masqué, car ta famille a choisi « Aucune religion »',
        searchHidden: 'Options masquées',
    },
    kitchens: {
        filterLabel: 'Cuisine',
        all: 'Toutes les cuisines',
    },
    menu: {
        suggestionsTitle: 'Propositions pour cette semaine',
        suggestionsHint: 'Touche une proposition et choisis un jour.',
        noSuggestions: 'Plus de propositions pour cette semaine.',
        whoEats: 'Qui est à table ?',
        everyoneEats: 'Tout le monde est à table',
        notEating: 'Pas à table : {names}',
        markerLabel: 'Attention pour ce plat : {text}',
        chooseDay: 'Choisis un jour pour {title}',
    },
    warning: {
        title: 'Est-ce que ça convient à tout le monde ?',
        swapped: 'Remplacé : {swap} au lieu de {ingredient}.',
        eatsOtherSaved: 'C’est noté : {name} mange autre chose avec ce plat.',
        added: 'Ajouté.',
    },
    recipes: {
        original: '{name}',
    },
};
//# sourceMappingURL=cultureApp.fr.js.map